module.exports = __webpack_public_path__ + "static/img/m_sidebar_about@3x.bae4ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_sidebar_about@3x.png
// module id = eonV
// module chunks = 1